import { createContext, useContext, useMemo } from 'react';
import { pagesByPath, type GuideCatalog, type PagesByPath } from './catalog';
import { GUIDE } from './content';

/** Il catalogo della Guida mostrato dalla web app: quello del manuale, sostituibile nei test. */
export const GuideCatalogContext = createContext<GuideCatalog>(GUIDE);

/** Il catalogo della Guida corrente. */
export function useGuideCatalog(): GuideCatalog {
  return useContext(GuideCatalogContext);
}

/** Le pagine della Guida per percorso, per risolvere i link tra pagine. */
export function usePagesByPath(): PagesByPath {
  const catalog = useGuideCatalog();
  return useMemo(() => pagesByPath(catalog.pages), [catalog]);
}
